import { ChatAction, MenuOption, MessageType, OperatorMessage } from './operatorChat.types';

export function chatReducer(state, message: OperatorMessage) {
  if (message.action === ChatAction.RESET_CHAT) {
    return {
      messages: [],
      menu: [],
    };
  }

  if (message.action === ChatAction.SHOW_MENU) {
    const newMessage = {
      message_type: MessageType.INFORMATIONAL,
      text: state.menu.map((i: MenuOption) => `[${i.text}](command${i.text}) — ${i.description}`).join('\n'),
      timestamp: message.timestamp || new Date().toISOString(),
    };
    return {
      ...state,
      messages: [...state.messages, newMessage],
    };
  }

  // Detect commands in user messages and convert all commands to resendable links
  if ([MessageType.INPUT, MessageType.COMMAND].includes(message.message_type) && message.text.trim().includes('/')) {
    // Replace all /command occurrences with markdown links
    const convertedText = message.text.replace(/(\/\w+)/g, (cmd) => `[${cmd}](command${cmd})`);

    return {
      ...state,
      messages: [
        ...state.messages,
        {
          ...message,
          text: convertedText,
        },
      ],
    };
  }

  if (
    [MessageType.INFORMATIONAL, MessageType.INPUT, MessageType.COMMAND, MessageType.UI_INFO].includes(
      message.message_type
    )
  ) {
    return {
      ...state,
      messages: [...state.messages, message],
    };
  }

  if (MessageType.EDIT === message.message_type) {
    const editedMessageIndex = state.messages.findIndex((m: OperatorMessage) => m.uuid === message.edited_message_uuid);
    const newMessage = {
      ...state.messages[editedMessageIndex],
      text: message.new_text,
      keyboard: message.new_keyboard,
    };
    return {
      ...state,
      messages: [
        ...state.messages.slice(0, editedMessageIndex),
        newMessage,
        ...state.messages.slice(editedMessageIndex + 1),
      ],
    };
  }

  if (MessageType.MENU === message.message_type) {
    return {
      ...state,
      menu: message.options,
    };
  }

  return state;
}
